export const SET_CHECKOUT_DATA = 'SET_CHECKOUT_DATA';
export const SET_SYSTEM_INFO = 'SET_SYSTEM_INFO';
export const SET_MEMBER_INFO = 'SET_MEMBER_INFO';
export const SET_MEMBER_INFO_ALI_CARD = 'SET_MEMBER_INFO_ALI_CARD';
export const SET_LOCAL_CART_GOODS = 'SET_LOCAL_CART_GOODS';
export const SET_CART_CHECKED_GOODS_ID = 'SET_CART_CHECKED_GOODS_ID';
export const REMOVE_CART_CHECKED_GOODS_ID = 'REMOVE_CART_CHECKED_GOODS_ID';
export const SET_CART_CHECKED_PRESENT = 'SET_CART_CHECKED_PRESENT';
export const SET_CART_NEW_RECEIVE_PRESENT = 'SET_CART_NEW_RECEIVE_PRESENT';
export const INIT_CART_STORE = 'INIT_CART_STORE';
export const RESET_CART_STORE = 'RESET_CART_STORE';
export const SET_LOGOUT_STATE = 'SET_LOGOUT_STATE';
export const SET_PAYMENT_DATA = 'SET_PAYMENT_DATA';
